import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  drawerTitle: {
    description: 'Order Import Drawer Title',
    defaultMessage: 'Import Orders from CSV File',
    id: 'b8iakD',
  },
  closeDrawerAriaLabel: {
    defaultMessage: 'Close Order Drawer',
    id: '9enjjq',
    description: 'Gives the user an aria label for the close button',
  },
});

export const orderImportFieldTranslations = defineMessages({
  OrderNumber: {
    defaultMessage: 'Order Number',
    id: 'dwsv0W',
    description: 'Order Number order import column name during mapping step',
  },
  OrderDate: {
    defaultMessage: 'Order Date',
    id: 'nE1LqA',
    description: 'Order Date order import column name during mapping step',
  },
  PayDate: {
    defaultMessage: 'Pay Date',
    id: 'Oez9sv',
    description: 'Pay Date order import column name during mapping step',
  },
  OrderTotal: {
    defaultMessage: 'Order Total',
    id: 'Fb86RC',
    description: 'Order Total order import column name during mapping step',
  },
  AmountPaid: {
    defaultMessage: 'Amount Paid',
    id: 'h4yN7U',
    description: 'Amount Paid order import column name during mapping step',
  },
  Tax: {
    defaultMessage: 'Tax',
    id: 'us/YtL',
    description: 'Tax order import column name during mapping step',
  },
  ShippingAmount: {
    defaultMessage: 'Shipping Amount',
    id: '6t/+oy',
    description: 'Shipping Amount order import column name during mapping step',
  },
  ShippingService: {
    defaultMessage: 'Shipping Service',
    id: '1FYMUe',
    description: 'Shipping Service order import column name during mapping step',
  },
  Weight: {
    defaultMessage: 'Weight',
    id: 'Eds7Vy',
    description: 'Weight order import column name during mapping step',
  },
  Height: {
    defaultMessage: 'Height',
    id: 'LGgd86',
    description: 'Height order import column name during mapping step',
  },
  Width: {
    defaultMessage: 'Width',
    id: 'kv1YAJ',
    description: 'Width order import column name during mapping step',
  },
  Length: {
    defaultMessage: 'Length',
    id: 'Z6NUP7',
    description: 'Length order import column name during mapping step',
  },
  CustomField1: {
    defaultMessage: 'Custom Field 1',
    id: 'cl/2Wv',
    description: 'Custom Field 1 order import column name during mapping step',
  },
  CustomField2: {
    defaultMessage: 'Custom Field 2',
    id: '9Xt2or',
    description: 'Custom Field 2 order import column name during mapping step',
  },
  CustomField3: {
    defaultMessage: 'Custom Field 3',
    id: 'WpxEk4',
    description: 'Custom Field 3 order import column name during mapping step',
  },
  Source: {
    defaultMessage: 'Order Source',
    id: 'vYd2Om',
    description: 'Source order import column name during mapping step',
  },
  BuyerName: {
    defaultMessage: 'Buyer Name',
    id: 'RI3Ntt',
    description: 'Buyer Name order import column name during mapping step',
  },
  BuyerFirstName: {
    defaultMessage: 'Buyer First Name',
    id: 'UPSaRF',
    description: 'Buyer First Name order import column name during mapping step',
  },
  BuyerLastName: {
    defaultMessage: 'Buyer Last Name',
    id: 'FrYZmp',
    description: 'Buyer Last Name order import column name during mapping step',
  },
  Email: {
    defaultMessage: 'Email',
    id: 'elA+Ms',
    description: 'Email order import column name during mapping step',
  },
  Phone: {
    defaultMessage: 'Phone',
    id: 'Tnz9b6',
    description: 'Phone order import column name during mapping step',
  },
  UserName: {
    defaultMessage: 'UserName',
    id: 'kSiFHb',
    description: 'UserName order import column name during mapping step',
  },
  Name: {
    defaultMessage: 'Name',
    id: 'JOPtkP',
    description: 'Name order import column name during mapping step',
  },
  FirstName: {
    defaultMessage: 'First Name',
    id: 'K+M4c0',
    description: 'First Name order import column name during mapping step',
  },
  LastName: {
    defaultMessage: 'Last Name',
    id: '0CkfmS',
    description: 'Last Name order import column name during mapping step',
  },
  RecipientPhone: {
    defaultMessage: 'Recipient Phone',
    id: '64/R96',
    description: 'Recipient Phone order import column name during mapping step',
  },
  Company: {
    defaultMessage: 'Company',
    id: '4dzLVW',
    description: 'Company order import column name during mapping step',
  },
  Address1: {
    defaultMessage: 'Address 1',
    id: '3kDn7q',
    description: 'Address 1 order import column name during mapping step',
  },
  Address2: {
    defaultMessage: 'Address 2',
    id: '5IB4A8',
    description: 'Address 2 order import column name during mapping step',
  },
  Address3: {
    defaultMessage: 'Address 3',
    id: 'GB9vzT',
    description: 'Address 3 order import column name during mapping step',
  },
  City: {
    defaultMessage: 'City',
    id: 'IC7uKa',
    description: 'City order import column name during mapping step',
  },
  State: {
    defaultMessage: 'State',
    id: '4w/dAm',
    description: 'State order import column name during mapping step',
  },
  PostalCode: {
    defaultMessage: 'Postal Code',
    id: 'ad/zvy',
    description: 'Postal Code order import column name during mapping step',
  },
  CountryCode: {
    defaultMessage: 'Country Code',
    id: 'aDLgfY',
    description: 'Country Code order import column name during mapping step',
  },
  ItemSku: {
    defaultMessage: 'Item SKU',
    id: 'fZRckK',
    description: 'Item SKU order import column name during mapping step',
  },
  ItemName: {
    defaultMessage: 'Item Name',
    id: 'eMqG2S',
    description: 'Item Name order import column name during mapping step',
  },
  ItemQuantity: {
    defaultMessage: 'Item Quantity',
    id: 'xxv4uW',
    description: 'Item Quantity order import column name during mapping step',
  },
  ItemUnitPrice: {
    defaultMessage: 'Item Unit Price',
    id: 'rCi0Th',
    description: 'Item Unit Price order import column name during mapping step',
  },
  ItemWeight: {
    defaultMessage: 'Item Weight',
    id: '11Fsuw',
    description: 'Item Weight order import column name during mapping step',
  },
  ItemOptions: {
    defaultMessage: 'Item Options',
    id: 'lt2voB',
    description: 'Item Options order import column name during mapping step',
  },
  ItemWarehouseLocation: {
    defaultMessage: 'Item Warehouse Location',
    id: 'QeOcvw',
    description: 'Item Warehouse Location order import column name during mapping step',
  },
  ItemExternalID: {
    defaultMessage: 'Item External ID',
    id: 'l5CZIK',
    description: 'Item External ID order import column name during mapping step',
  },
  NotesFromBuyer: {
    defaultMessage: 'Notes From Buyer',
    id: 'AgHOlx',
    description: 'Notes From Buyer order import column name during mapping step',
  },
  NotesToBuyer: {
    defaultMessage: 'Notes To Buyer',
    id: 'r0kXFh',
    description: 'Notes To Buyer order import column name during mapping step',
  },
  InternalNotes: {
    defaultMessage: 'Internal Notes',
    id: 'PhFhXX',
    description: 'Internal Notes order import column name during mapping step',
  },
  GiftMessage: {
    defaultMessage: 'Gift Message',
    id: 'WEgsqO',
    description: 'Gift Message order import column name during mapping step',
  },
  Gift: {
    defaultMessage: 'Is Gift',
    id: '49g0Am',
    description: 'Is Gift order import column name during mapping step',
  },
});
